import { useQuery } from '@tanstack/react-query'
import reportService, {
  FiltrosReporte,
  OcupacionResponse,
  IngresoResponse,
  EspacioTopResponse,
  MetodoPagoResponse,
  ControlResponse
} from '@/services/reportService'

export const useReportOcupacion = (filtros: FiltrosReporte) => {
  return useQuery<OcupacionResponse>({
    queryKey: ['reportes', 'ocupacion', JSON.stringify(filtros)],
    queryFn: () => reportService.getOcupacion(filtros),
    enabled: true,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: 1
  })
}

export const useReportIngresos = (filtros: FiltrosReporte) => {
  return useQuery<IngresoResponse>({
    queryKey: ['reportes', 'ingresos', JSON.stringify(filtros)],
    queryFn: () => reportService.getIngresos(filtros),
    enabled: true,
    staleTime: 5 * 60 * 1000,
    retry: 1
  })
}

export const useReportEspaciosTop = (filtros: FiltrosReporte) => {
  return useQuery<EspacioTopResponse>({
    queryKey: ['reportes', 'espacios-top', JSON.stringify(filtros)],
    queryFn: () => reportService.getEspaciosTop(filtros),
    enabled: true,
    staleTime: 5 * 60 * 1000,
    retry: 1
  })
}

export const useReportMetodosPago = (filtros: FiltrosReporte) => {
  return useQuery<MetodoPagoResponse>({
    queryKey: ['reportes', 'metodos-pago', JSON.stringify(filtros)],
    queryFn: () => reportService.getMetodosPago(filtros),
    enabled: true,
    staleTime: 5 * 60 * 1000,
    retry: 1
  })
}

export const useReportControl = (filtros: FiltrosReporte & { mostrar_solo_problemas?: boolean }) => {
  return useQuery<ControlResponse>({
    queryKey: ['reportes', 'control', JSON.stringify(filtros)],
    queryFn: () => reportService.getControl(filtros),
    enabled: true,
    staleTime: 5 * 60 * 1000,
    retry: 1
  })
}
